import React, { useMemo } from 'react';

import { Container, Card, Button, Title, LanguageSelector, LanguageButton, MenuContainer, FloatingSuits } from '../../styles/GlobalStyles';

const MenuScreen = ({
  currentGame,
  language,
  setLanguage,
  onStartNewGame,
  onContinueGame,
  onViewHistory,
  onViewRules,
  translations
}) => {
  const t = translations[language];

  const showMainFirst = useMemo(() => Math.random() < 0.5, []);

  return (
    <>
      <FloatingSuits>
        <div className="suit" data-suit="spade">♠</div>
        <div className="suit" data-suit="heart">♥</div>
        <div className="suit" data-suit="diamond">♦</div>
        <div className="suit" data-suit="club">♣</div>
        <div className="suit" data-suit="spade">♠</div>
        <div className="suit" data-suit="heart">♥</div>
        <div className="suit" data-suit="diamond">♦</div>
        <div className="suit" data-suit="club">♣</div>
        <div className="suit" data-suit="spade">♠</div>
        <div className="suit" data-suit="heart">♥</div>
        <div className="suit" data-suit="diamond">♦</div>
        <div className="suit" data-suit="club">♣</div>
        <div className="suit" data-suit="spade">♠</div>
        <div className="suit" data-suit="heart">♥</div>
        <div className="suit" data-suit="diamond">♦</div>
        <div className="suit" data-suit="club">♣</div>
      </FloatingSuits>


      <MenuContainer>
        <Title>{t.appTitle}</Title>

        {/* <LanguageSelector>
          <LanguageButton
            active={language === 'nl'}
            onClick={() => setLanguage('nl')}
          >
            Nederlands
          </LanguageButton>
          <LanguageButton
            active={language === 'en'}
            onClick={() => setLanguage('en')}
          >
            English
          </LanguageButton>
        </LanguageSelector> */}

        <Card>
          <Button onClick={onStartNewGame}>
            {t.startNewGame}
          </Button>

          <Button
            onClick={onContinueGame}
            disabled={!currentGame}
            variant={currentGame ? 'success' : 'secondary'}
          >
            {t.continueGame}
          </Button>

          <Button
            variant="secondary"
            onClick={onViewHistory}
          >
            {t.history}
          </Button>

          <Button
            variant="secondary"
            onClick={onViewRules}
          >
            {t.rules}
          </Button>
        </Card>

        {/* {currentGame && (
          <Card>
            <h3 style={{ marginBottom: '15px', color: '#4CAF50' }}>
              {t.inProgress}
            </h3>
            <div style={{ fontSize: '14px', color: '#666' }}>
              <div><strong>{t.round}:</strong> {currentGame.currentRound}</div>
              <div><strong>{t.players}:</strong> {currentGame.players.map(p => p.name).join(', ')}</div>
            </div>
          </Card>
        )} */}

        {showMainFirst ? (
          <>
            <Card style={{ flex: '1 1 0', minWidth: '220px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
                {'Hoofdsponsor:'} <br /> {'Wageningse Rikvereniging'}
              </h3>
              {/* <img
                src="/rikkenLogo.svg"
                alt="Wageningse rikvereneging"
                style={{ width: '120px', height: 'auto', marginTop: '8px', display: 'block' }}
              /> */}
            </Card>
            <Card>
              <h3 style={{ marginBottom: '15px' }}>
                {t.supportDeveloper}
              </h3>
              <Button
                onClick={() => window.open('https://ko-fi.com/pimvh', '_blank')}
              >
                {t.buyMeABeer}
              </Button>
            </Card>
          </>
        ) : (
          <>
            <Card>
              <h3 style={{ marginBottom: '15px' }}>
                {t.supportDeveloper}
              </h3>
              <Button
                onClick={() => window.open('https://ko-fi.com/pimvh', '_blank')}
              >
                {t.buyMeABeer}
              </Button>
            </Card>
            <Card style={{ flex: '1 1 0', minWidth: '220px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
                {/* {t.mainSponsor} */}
                {'Hoofdsponsor:'} <br /> {'Wageningse Rikvereniging'}
              </h3>
              {/* <img
                src="/rikkenLogo.svg"
                alt="Wageningse rikvereneging"
                style={{ width: '120px', height: 'auto', marginTop: '8px', display: 'block' }}
              /> */}
            </Card>
          </>
        )}


        {/* <Card style={{ flex: '1 1 0', minWidth: '220px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
            {t.mainSponsor}
          </h3>
          <img
            src="/rikkenLogo.svg"
            alt="Wageningse rikvereneging"
            style={{ width: '120px', height: 'auto', marginTop: '8px', display: 'block' }}
          />
        </Card>
        <Card>
          <h3 style={{ marginBottom: '15px' }}>
            {t.supportDeveloper}
          </h3>
          <Button
            onClick={() => window.open('https://ko-fi.com/pimvh', '_blank')}
          >
            {t.buyMeABeer}
          </Button>
        </Card> */}

        {/* <div style={{ display: 'flex', gap: '24px', justifyContent: 'space-between', alignItems: 'stretch', flexWrap: 'wrap', width: '100%' }}>
          <Card style={{ flex: '1 1 0', minWidth: '220px' }}>
            <h3 style={{ marginBottom: '15px' }}>
              {t.supportDeveloper}
            </h3>
            <Button
              onClick={() => window.open('https://ko-fi.com/pimvh', '_blank')}
            >
              {t.buyMeABeer}
            </Button>
          </Card>
          <Card style={{ flex: '1 1 0', minWidth: '220px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
              {t.mainSponsor}
            </h3>
            <img
              src="/rikkenLogo.svg"
              alt="Wageningse rikvereneging logo"
              style={{ width: '120px', height: 'auto', marginTop: '8px', display: 'block' }}
            />
          </Card>
        </div> */}
      </MenuContainer>
    </>
  );
};

export default MenuScreen;
